import CardSliderModule from '@/components/ProductDetailComponents/CardSliderModule';
import CardModule from '@/componentsH5/ProductDetailComponents/CardModule';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/dg200/');

export default function SliderI() {
    const { isMobile, useLang, useEffect, useRouter } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const { locale } = useRouter();
    const sliderData = [
        {
            img: [
                `${isMobile ? 'h5/' : 'pc/'}8_1${locale === 'cn' ? `_${locale}` : ''}.webp`,
                `${isMobile ? 'h5/' : 'pc/'}8_1${locale === 'cn' ? `_${locale}` : ''}.png`,
            ],
            desc: t('dg200.sliderI_text1'),
        },
        {
            img: [
                `${isMobile ? 'h5/' : 'pc/'}8_2${locale === 'cn' ? `_${locale}` : ''}.webp`,
                `${isMobile ? 'h5/' : 'pc/'}8_2${locale === 'cn' ? `_${locale}` : ''}.png`,
            ],
            desc: t('dg200.sliderI_text2'),
        },
        {
            img: [
                `${isMobile ? 'h5/' : 'pc/'}8_3${locale === 'cn' ? `_${locale}` : ''}.webp`,
                `${isMobile ? 'h5/' : 'pc/'}8_3${locale === 'cn' ? `_${locale}` : ''}.png`,
            ],
            desc: t('dg200.sliderI_text3'),
        },
        {
            img: [
                `${isMobile ? 'h5/' : 'pc/'}8_4${locale === 'cn' ? `_${locale}` : ''}.webp`,
                `${isMobile ? 'h5/' : 'pc/'}8_4${locale === 'cn' ? `_${locale}` : ''}.png`,
            ],
            desc: t('dg200.sliderI_text4'),
        },
    ];
    const styles = {
        theme: 'black',
        wrapperBack: 'transparent',
        webpUrl: '/media/dg200/',
    };

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .sliderI ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: isMobile ? '-.44rem' : '-60px',
            triggerHook: 0,
            duration: targetH,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.title');
            textFadeInOut('.desc');
            textFadeInOut('.sup');
        }
    }, []);

    return (
        <div className={`sliderI ${css.sliderI} ${isMobile ? 'sliderI_h5' : 'sliderI_pc'}`}>
            {!isMobile && (
                <>
                    <div className="textBox">
                        <p className="title">{t('dg200.sliderI_title')}</p>
                        <p className="desc">{t('dg200.sliderI_desc')}</p>
                        <p className="sup">{t('dg200.sliderI_sup')}</p>
                    </div>
                    <div className="sliderBox">
                        <CardSliderModule cssStyle={styles} data={sliderData} />
                    </div>
                </>
            )}
            {isMobile && (
                <div className="boxH5">
                    <div className="textBox">
                        <p className="title">{t('dg200.sliderI_title')}</p>
                        <p className="desc">{t('dg200.sliderI_desc')}</p>
                        <p className="sup">{t('dg200.sliderI_sup')}</p>
                    </div>
                    <CardModule
                        cssStyle={{ textAlign: 'left', backColor: '#000', webpUrl: '/media/dg200/' }}
                        data={{
                            type: 'textImageSlide',
                            items: sliderData?.map((item: any) => ({
                                url: item.img,
                                title: item.desc,
                            })),
                        }}
                    />
                </div>
            )}
        </div>
    );
}
